"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DomHelper {
    /**
     * @inheritDoc
     */
    isChildOf(parent, child) {
        let targetElement = child;
        do {
            if (targetElement == parent) {
                return true;
            }
        } while (targetElement = targetElement.parentNode);
        return false;
    }
}
exports.default = DomHelper;
